import {Injectable} from '@angular/core';
import {map} from 'rxjs/operators';
import {ApiService} from './api.service';

@Injectable()
export class SubscriptionsService {

  constructor(
    private apiService: ApiService
  ) {
  }

  getAll(query) {
    return this.apiService.get(
      `/subscriptions${query}`
    );
  }

  get(id: string) {
    return this.apiService.get(`/subscriptions/${id}`)
      .pipe(
        map(
          (result: any) => result.data
        )
      );
  }

  create(subscription, plan: Plan) {
    const startDate = new Date(subscription.start_date);
    let endDate = new Date(subscription.start_date);

    const year = startDate.getFullYear();
    const month = startDate.getMonth();
    const day = startDate.getDate();

    switch (plan.type) {
      case 'yearly':
        endDate = new Date(year + 1, month, day);
        break;
      case 'mountly':
        endDate = new Date(year, month + 1, day);
        break;
      case '6mounth':
        endDate = new Date(year, month + 6, day);
        break;
      case '3mounth':
        endDate = new Date(year, month + 3, day);
        break;
    }

    subscription.start_date = `${startDate.getMonth() + 1}/${startDate.getDate()}/${startDate.getFullYear()}`;
    subscription.end_date = `${endDate.getMonth() + 1}/${endDate.getDate()}/${endDate.getFullYear()}`;
    subscription.total_price = plan.price;
    subscription.amount_paid = 0;
    return this.apiService.post(`/subscriptions`, subscription);
  }

  update(id, subscription, plan) {

    const startDate = new Date(subscription.start_date);
    let endDate = new Date(subscription.start_date);

    const year = startDate.getFullYear();
    const month = startDate.getMonth();
    const day = startDate.getDate();

    switch (plan.type) {
      case 'yearly':
        endDate = new Date(year + 1, month, day);
        break;
      case 'mountly':
        endDate = new Date(year, month + 1, day);
        break;
      case '6mounth':
        endDate = new Date(year, month + 6, day);
        break;
      case '3mounth':
        endDate = new Date(year, month + 3, day);
        break;
    }

    subscription.start_date = `${startDate.getMonth() + 1}/${startDate.getDate()}/${startDate.getFullYear()}`;
    subscription.end_date = `${endDate.getMonth() + 1}/${endDate.getDate()}/${endDate.getFullYear()}`;
    subscription.total_price = plan.price;

    return this.apiService.put(`/subscriptions/${id}`, subscription);
  }

  destroy(id) {
    return this.apiService.delete(`/subscriptions/${id}`);
  }

  search(keyword) {
    return this.apiService.post(`/subscriptions/search`, {
      keyword
    })
      .pipe(
        map(
          (result: any) => result.data
        )
      );
  }

}
